import { styled } from "@mui/material";

import { Slider as UnstyledSlider } from "./slider";
import { TextField } from "./text-field";

export const SliderAndTextFieldContainer = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(3),
}));

export const SliderContainer = styled("div")({
  display: "flex",
  flex: 2,
});

export const Slider = styled(UnstyledSlider)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}));

export const SliderTextfield = styled(TextField)(({ theme }) => ({
  alignSelf: "flex-end",
  width: theme.spacing(13),
}));
